import {bossWebAxios} from '../api';

export const operate = (params, url, config) => bossWebAxios(params, `operator/login/${url}`, config)
export const register = (params, url, config) => bossWebAxios(params, `operator/register/${url}`, config)
export const password = (params, url, config) => bossWebAxios(params, `operator/password/${url}`, config);
export const captcha = (params, url, config) => bossWebAxios(params, `authcenter/jwt/captcha`, config);
